export default {
  'menu.workbenchGroup': 'ワークベンチ',
  'menu.workbench': 'ワークベンチ',
  'menu.activitiesGroup': 'アクティビティセンター',
  'menu.activities': 'アクティビティセンター',
  'menu.activityDetail': 'アクティビティ詳細',
  'menu.technicalNeeds': '技術ニーズ',
  'menu.technicalNeeds.leads': 'ニーズリード',
  'menu.technicalNeeds.demands': '技術ニーズ',
  'menu.leads': 'ニーズリード',
  'menu.leadDetail': 'リード詳細',
  'menu.customers': '顧客・連絡先',
  'menu.customers.organizations': '組織',
  'menu.customers.contacts': '連絡先',
  'menu.relations': '顧客・連絡先',
  'menu.relations.organizations': '組織',
  'menu.relations.contacts': '連絡先',
  'menu.organizations': '組織',
  'menu.contacts': '連絡先',
  'menu.organizationDetail': '組織詳細',
  'menu.contactDetail': '連絡先詳細',
  'menu.demands': '技術ニーズ',
  'menu.demandDetail': '技術ニーズ詳細',
  'menu.technicalResources': '技術リソース',
  'menu.technicalResources.experts': '専門家リソース',
  'menu.technicalResources.technologies': '技術成果',
  'menu.resources': '技術リソース',
  'menu.resources.experts': '専門家リソース',
  'menu.resources.technologies': '技術成果',
  'menu.resources.suppliers': '組織管理',
  'menu.experts': '専門家リソース',
  'menu.technologies': '技術成果',
  'menu.businessConversion': 'ビジネス転換',
  'menu.businessConversion.matchmaking': '需要マッチング',
  'menu.businessConversion.engagements': '正式マッチング',
  'menu.businessConversion.opportunities': 'ビジネス商機',
  'menu.businessConversion.conversionBusinesses': '転換業務',
  'menu.matchmaking': '需要マッチング',
  'menu.engagements': '正式マッチング',
  'menu.expertDetail': '専門家詳細',
  'menu.technologyDetail': '技術成果詳細',
  'menu.supplierDetail': 'サプライヤー詳細',
  'menu.opportunities': 'ビジネス商機',
  'menu.opportunityDetail': '商機詳細',
  'menu.businessAnalytics': 'ビジネス統計',
  'menu.businessDashboard': 'ビジネス統計',
  'menu.personalProfile': 'プロフィール',
  'menu.personalSettings': '個人・設定',
  'menu.personalSettings.managerProfile': 'プロフィール',
  'menu.personalSettings.businessSettings': 'ビジネス設定',
  'menu.personalSettings.modelSettings': 'モデル設定',
  'menu.personalSettings.dataManagement': 'データ管理',
  'menu.personalSettings.permissions': '権限管理',
  'menu.managerProfile': 'プロフィール',
  'menu.businessSettings': 'ビジネス設定',
  'menu.modelSettings': 'モデル設定',
  'menu.dataManagement': 'データ管理',
  'menu.permissions': '権限管理',
  'menu.settings': '設定',
  'menu.settings.businessSettings': 'ビジネス設定',
  'menu.settings.modelSettings': 'モデル設定',
  'menu.settings.dataManagement': 'データ管理',
  'menu.settings.mockData': 'データ管理',
  'menu.globalSearch': 'グローバル検索',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings.permissions': '権限管理',
  'menu.login': 'ログイン',
  'menu.user.login': 'ログイン',
  'menu.user.accessDenied': 'アクセス拒否',
  'menu.accessDenied': 'アクセス拒否',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
